var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.476074 3.48746C0.476074 2.82371 1.01415 2.28564 1.67789 2.28564H10.7482C11.4119 2.28564 11.95 2.82371 11.95 3.48746V5.21405C12.0305 5.19706 12.1139 5.18813 12.1994 5.18813H14.5637C14.9274 5.18813 15.2715 5.35279 15.4996 5.63599L18.9403 9.90703C19.1124 10.1206 19.2062 10.3867 19.2062 10.661V15.0974C19.2062 15.7612 18.6682 16.2992 18.0044 16.2992L1.67789 16.2992C1.01415 16.2992 0.476074 15.7612 0.476074 15.0974V3.48746ZM1.67789 3.23803C1.54013 3.23803 1.42846 3.3497 1.42846 3.48746V15.0974C1.42846 15.2352 1.54013 15.3469 1.67789 15.3469H10.9976V3.48746C10.9976 3.3497 10.8859 3.23803 10.7482 3.23803H1.67789ZM12.1994 6.14051C12.0617 6.14051 11.95 6.25218 11.95 6.38994V9.90469H17.7155L14.758 6.23346C14.7106 6.17468 14.6392 6.14051 14.5637 6.14051H12.1994ZM18.2539 10.8571H11.95V15.3469H18.0044C18.1422 15.3469 18.2539 15.2352 18.2539 15.0974V10.8571Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36974 15.8231C7.36974 16.7624 6.60832 17.5238 5.66906 17.5238C4.7298 17.5238 3.96838 16.7624 3.96838 15.8231C3.96838 14.8839 4.7298 14.1224 5.66906 14.1224C6.60832 14.1224 7.36974 14.8839 7.36974 15.8231ZM16.8028 15.8231C16.8028 16.7624 16.0414 17.5238 15.1022 17.5238C14.1629 17.5238 13.4015 16.7624 13.4015 15.8231C13.4015 14.8839 14.1629 14.1224 15.1022 14.1224C16.0414 14.1224 16.8028 14.8839 16.8028 15.8231Z",
    fill: "white",
    stroke: "#1B1B1B",
    strokeWidth: 0.952381
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.32eace61482fea8d5a8d449b36a42d25.svg";
export { ForwardRef as ReactComponent };